<template>
  <v-container class="pa-0">
    <v-btn
      block
      outlined
      text
      :disabled="busy"
      @click="newCard=!newCard"
    >
      <v-icon
        class="pr-3"
      >
        mdi-credit-card-plus-outline
      </v-icon>
      New Method
    </v-btn>

    <v-expand-transition>
      <div
        v-show="newCard"
        class="mt-4"
      >
        <v-badge
          left
          icon="mdi-test-tube"
          :value="stripeStatus.test == 'test'"
        >
          <v-card
            flat
            color="indigo lighten-5"
            min-width="350"
          >
            <v-card-text>
              <v-text-field
                v-model="name"
                label="Name on card"                
              />
              <div
                id="pcard-element-payment"
              />
              <div
                id="pcard-errors"
                role="alert"
              />
            </v-card-text>
            
            <v-card-actions class="d-flex justify-end">
              <v-btn
                outlined
                elevation="0"
                :disabled="!cardIsReady || !name || busy" 
                @click="createPaymentMethod"
              >
                Save Card
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-badge>
      </div>
    </v-expand-transition>
  </v-container>
</template>

<script>
export default {
  props: ['busy'],
  data(){
    return {
      newCard: false,
      stripeOptions: {
        style: {
          base: {
            backgroundColor: '#fff',
            fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
            fontSize: '16px',
            fontSmoothing: 'antialiased',
          },
        },
      },
      stripe: '',
      elements: '',
      card: '',
      cardIsReady: false,
      name: null,
      customer: null,
      stripeStatus: {}
    }
  },
  computed: {
    stripeCustomerID(){return (this.auth.stripe.customer||{}).id},
    shopID(){return this.$store.state.market.shopID},
  },
  created(){
    this.name = this.auth.stripe.customer
      && this.auth.stripe.customer.name
      || this.auth.name
    this.loadStripeDependencies()
  },
  methods: {
    async loadStripeDependencies(){
      this.stripeStatus = await this.api.get('/stripe/market/status/') || {}
      this.includeStripe('js.stripe.com/v3/', function(){
          this.configureStripe();
      }.bind(this) );
    },

    configureStripe(){
        this.stripe = window.Stripe( this.stripeStatus.public_key );
        this.elements = this.stripe.elements();
        this.card = this.elements.create('card', this.stripeOptions);
        this.card.mount('#pcard-element-payment');
        this.card.on('change', evt=>{
          if (this.cardIsReady !== evt.complete) {
            this.cardIsReady = evt.complete
          }
        })
    },
    includeStripe( URL, callback ){
        let documentTag = document, tag = 'script',
            object = documentTag.createElement(tag),
            scriptTag = documentTag.getElementsByTagName(tag)[0];
        object.src = '//' + URL;
        if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
        scriptTag.parentNode.insertBefore(object, scriptTag);
    },

    async createPaymentMethod(){
      this.$emit('busy', true)
      let result = await this.stripe.createPaymentMethod({
        type: 'card',
        card: this.card,
        billing_details: {
          name: this.name,
        },
      })
      if (result && result.paymentMethod) {
        await this.api.post(`/stripe/attach_payment_method/${result.paymentMethod.id}`)
        this.newCard = false
        this.$emit('busy', false)
        this.$emit('fetch')
      }
    },
  }
}
</script>